import type { Apollo } from 'src/gql/generated';
import type { AccountSubset, UserDefinedRoleSubset } from 'src/types/apollo/accounts';

export interface WorkflowPermissionSubset extends Pick<
  Apollo.WorkflowPermission,
  'accessLevel' | 'id' | 'isAssignee' | 'timeliness' | '__typename' | 'isExternal'
> {
  account: AccountSubset | null;
  role: UserDefinedRoleSubset | null;
}

export function getIsRolePermission(permission: {
  account: AccountSubset | null;
  role: UserDefinedRoleSubset | null;
}): boolean {
  return Boolean(permission.role) && permission.account?.__typename !== 'User';
}
